import { SET_UTM_CAMPAIGN_SOURCE_TYPE } from 'actions';

export const setUtmCampaignSourceType = (utmCampaign: string) => {
  return { type: SET_UTM_CAMPAIGN_SOURCE_TYPE, utmCampaign };
};
